import { useQuery } from '@tanstack/react-query';

import { useMemo } from 'react';
import { getAvailableActionsForRSims } from 'rSimInventory/Actions/api/rsimActionsApi.ts';
import { rSimProductsQueries } from 'rSimInventory/utils/rsimProductsQueries.ts';
import { RSimInventoryItem } from 'rSimInventory/constants/rsim.ts';
import { useIsRSimInLifeChangesAvailable } from 'rSimInventory/Actions/hooks/useIsRSimInLifeChangesAvailable.ts';

export const useExtendsRSimProductsWithActionsAvailability = (
  rsimProducts: RSimInventoryItem[],
) => {
  const inlifeChangesEnabled = useIsRSimInLifeChangesAvailable();
  const euiccs = rsimProducts.map((rsim) => rsim.euicc);

  const { data: availableRSimActions } = useQuery({
    queryKey: rSimProductsQueries.availableActions({ euiccs }),
    queryFn: () => getAvailableActionsForRSims({ euiccs }),
    enabled: inlifeChangesEnabled,
  });

  return useMemo(() => {
    return rsimProducts.map((rsimProduct) => ({
      ...rsimProduct,
      availableActions: new Set(availableRSimActions?.[rsimProduct.euicc] ?? []),
    }));
  }, [rsimProducts, availableRSimActions]);
};
